const TIPOS_MOMENTO_APLICACION_REGLAS_FILTROS = [
  {
    id: 1,
    name: 'Solo en vigilancia',
  },
  {
    id: 2,
    name: 'Solo en descarga',
  },
  {
    id: 3,
    name: 'En vigilancia y en descarga',
  },
  {
    id: 4,
    name: 'En vigilancia en todos los casos'
  },
  {
    id: 5,
    name: 'En descarga en todos los casos'
  }
]

export {
  TIPOS_MOMENTO_APLICACION_REGLAS_FILTROS
}

